import { render, staticRenderFns } from "./index.vue?vue&type=template&id=a45ced3c&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=a45ced3c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a45ced3c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/publish/iot-cloud-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a45ced3c')) {
      api.createRecord('a45ced3c', component.options)
    } else {
      api.reload('a45ced3c', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=a45ced3c&scoped=true", function () {
      api.rerender('a45ced3c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/baseInfo/xseries/index.vue"
export default component.exports